import { render, staticRenderFns } from "./VDesigningPointerBar.vue?vue&type=template&id=5daaaa98&"
import script from "./VDesigningPointerBar.vue?vue&type=script&lang=ts&"
export * from "./VDesigningPointerBar.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningPointerBar.vue?vue&type=style&index=0&id=5daaaa98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports